import React from "react"
import styled from "@emotion/styled"
import { Box, Flex } from "@rebass/grid/emotion"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

import Image from "../../../../image"

// men From the Inside LP override classes all contain 'fti' in name

export const ATCFullWrap = styled.div`
  background: linear-gradient(to bottom, #f8f8f5 0%, #fff 100%);

  &.container-override {
    background: ${theme.color.white} !important;
  }

  &.mens-fti-atcfullwrap {
    background: ${theme.color.beige} !important;
    margin: auto;
  }

  .supplinkwrap {
    #Modal {
      margin: 0 auto;
      max-height: 100%;
      height: auto;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      @media (min-width: 768px) {
        max-width: 515px;
      }

      > div {
        padding: 12px 12px;
        background: #fff;
        border-radius: 16px;
      }
    }
  }

  .supplinkmob {
    display: block;
    margin: auto;

    @media (max-width: 767px) {
      margin-left: auto !important;
      margin-right: auto !important;
      margin-top: 32px !important;
    }
  }

  .left {
    text-align: left;
    padding: 0 5%;
  }

  .upsellwrap {
    #CloseWrapper {
      background: none;
      box-shadow: none;
      transform: scale(1.2);
    }

    #Modal {
      padding: 0 16px 16px;
      @media (min-width: 768px) {
        max-width: 510px;
        padding: 0 16px 24px;
      }
      @media (min-width: 1024px) {
        max-width: 750px;
      }

      > div:not(#ModalBody) {
        transform: translate(8px, -8px);
      }
    }
  }

  .gws-modal {
    #Modal {
      > div {
        border-radius: 0 !important;
      }
      .modal-header {
        > div > div > div {
          margin-top: 6px;
          align-items: flex-start !important;
        }
      }
      #ModalBody {
        padding-top: 80px !important;
      }
      @media (min-width: 768px) {
        max-width: 880px !important;
        max-height: 416px !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        .modal-header {
          padding: 36px 40px 24px !important;
          align-items: flex-start !important;
          > div > div > div {
            margin-top: 0;
            align-items: center !important;
          }
        }
        #ModalBody {
          padding: 72px 30px 36px 30px !important;
          overflow: hidden !important;
        }
      }
      @media (min-width: 1024px) {
        max-height: 450px !important;
      }
    }
  }

  .gwpwrap {
    .modal-nova {
      z-index: 100000;
    }
    .modal-nova-header {
      @media (max-width: 767px) {
        height: max-content;
        padding-bottom: 16px !important;
      }
      @media (min-width: 768px) {
        padding: 24px !important;
      }
      @media (min-width: 1024px) {
        padding: 40px !important;
      }

      * {
        color: ${theme.wild.color.men.brand.blue[100]};
      }
    }
    .modal-nova-header + div {
      @media (min-width: 1024px) {
        padding-left: 40px !important;
        padding-right: 40px !important;
      }

      .main-content {
        * {
          color: ${theme.wild.color.men.brand.blue[100]};
        }
      }
    }
  }
`
export const ATCWrap = styled(Flex)`
  flex-direction: row;
  width: 100%;
  max-width: 1400px;
  padding: 48px 0 0 0;
  margin-left: auto;
  margin-right: auto;

  &.atcwrap-fti {
    flex-direction: column;
    padding: 24px 0 0 0;
    @media (min-width: 1024px) {
      flex-direction: row;
      align-items: center;
      padding: 80px 0 0 0;
    }
    @media (min-width: 1280px) {
      padding: 112px 0 0 0;
      align-items: baseline;
    }
  }

  @media (min-width: 768px) {
    padding: 90px 24px 0;
  }
  @media (min-width: 1024px) {
    padding: 90px 24px 0;
  }
  @media (min-width: 1100px) {
    padding: 90px 0 0 0;
  }

  .product-image {
    margin: 0 auto;
  }
`

export const TitleAndInfo = styled(Box)`
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 40px;

  &.men-fti-titleandinfo {
    @media (min-width: 768px) {
      max-width: 70%;
      margin: auto;
    }
    @media (min-width: 1024px) {
      max-width: unset;
      padding-left: 0;
      padding-right: 40px;
    }
    @media (min-width: 1280px) {
      padding-left: 40px;
      max-width: 45%;
    }
  }

  .supplink {
    border-bottom: 1px solid ${theme.wild.color.men.primary.default};
    margin: 0;
    @media (min-width: 768px) {
      margin: 32px 0 0 0;
    }
  }

  .men-fti-supplink {
    @media (min-width: 768px) {
      margin: 0;
    }
  }

  .container-dosage {
    span {
      display: inline-block !important;
    }
  }

  @media (min-width: 768px) {
    padding-right: 0;
    padding-left: 25px;
    padding-bottom: 0;
    .sticky {
      max-width: 490px;
      margin: 0 auto;
      top: 120px;
      z-index: 0;
    }
  }
  @media (min-width: 1170px) {
    padding-left: 0;
  }

  h2 {
    @media (max-width: 340px) {
      font-size: 30px !important;
    }
    @media (min-width: 768px) {
      text-align: left;
    }
  }

  .link-with-arrow {
    text-transform: none;
  }
`

export const TitleAndInfoPartner = styled(Box)`
  padding-left: 16px;
  padding-right: 16px;

  .supplink {
    border-bottom: 1px solid ${theme.wild.color.men.primary.default};
    margin: 16px auto;
    display: block;
    @media (min-width: 1024px) {
      margin: 16px 0 40px;
    }
  }

  .supplink-partner {
    border-bottom: 1px solid ${theme.wild.color.men.primary.default};
    margin: 0 auto;
    display: block;
    @media (min-width: 1024px) {
      margin: 0;
    }
  }

  .container-dosage {
    span {
      display: inline-block !important;
    }
  }

  .sticky {
    max-width: 528px;
    margin: 0 auto;
    top: 120px;
    z-index: 0;
    @media (min-width: 1024px) {
      max-width: 584px;
    }
  }

  @media (min-width: 1440px) {
    padding-left: 0;
    padding-right: 0;
  }

  h1 {
    @media (max-width: 767px) {
      letter-spacing: 0.5px;
    }
  }

  h2 {
    @media (max-width: 340px) {
      font-size: 30px !important;
    }
    @media (min-width: 768px) {
      text-align: left;
    }
  }
`

export const ImageWrap = styled(Box)`
  margin: 10px 0 35px;
  position: relative;

  @media (min-width: 768px) {
    margin: 0 auto;
    .sticky {
      top: 250px;
      z-index: 0;
    }
  }

  .men-fti-image {
    width: 100%;
    max-width: 487px;
    @media (min-width: 768px) {
      width: 52vw;
      max-width: 579px;
    }
    @media (min-width: 1280px) {
      margin-top: 210px;
      max-width: 761px;
    }
    @media (min-width: 1520px) {
      margin-top: 155px;
    }
  }
`

export const ImageWrapPartner = styled(Box)`
  margin: 0 auto;
`

export const Title = styled(Flex)`
  width: auto;
  margin: auto;

  svg,
  h2 {
    display: inline-block;
  }

  svg {
    width: 48px;
    height: 48px;
  }

  align-items: center;
  justify-content: center;
  text-align: center;
  @media (min-width: 400px) {
    width: 320px;
    margin: auto;
  }
  @media (min-width: 768px) {
    text-align: left;
    justify-content: unset;
    margin: 0;
    width: auto;
  }

  .NavIconWrap {
    min-width: 48px;
  }

  .title {
    @media (min-width: 768px) and (max-width: 1023px) {
      font-size: 32px !important;
    }
  }
`

export const IconsWrap = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-content: space-between;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`

export const Icon = styled(Flex)`
  flex-direction: row;

  > div {
    padding: 0;
    @media (min-width: 500px) {
      padding: 0;
    }
    @media (min-width: 768px) {
      text-align: center;
      padding: 0 2vw;
    }
  }

  img {
    margin: auto;
    width: 42px;
    @media (min-width: 768px) {
      width: 28px;
    }
    @media (min-width: 1280px) {
      width: 38px;
    }
  }

  .el-text {
    padding: 10px 0 0 0;

    br {
      display: none;
    }

    @media (max-width: 767px) {
      font-size: 14px !important;
    }
  }

  @media (min-width: 768px) {
    .el-text {
      padding: 0 0 0 4px;

      br {
        display: block;
      }
    }

    > div {
      text-align: left;
      padding: 0;
      align-self: center;
    }
  }
`
export const ModalContentImage = styled.div`
  padding: 24px 0;
`

export const GiftBanner = styled(Flex)`
  border: 1px #c8d2d1 solid;
  border-radius: 4px;
  background-color: #f8f8f5;
  padding: 4px 8px 4px 0;
  align-items: center;
  @media (min-width: 480px) {
    padding: 4px 8px;
  }
  @media (min-width: 1280px) {
    padding: 3px 32px;
    p {
      font-size: 16px !important;
      line-height: 22.4px !important;
    }
  }
  .sup {
    transform: translateY(-5px);
  }
`
export const MenOptionsWrap = styled(Box)`
  .men-options-radio {
    max-width: none;
  }
`

export const ModalContent = ({ image }) => {
  return (
    <ModalContentImage className={`ModalContentImage`}>
      <Image filename={image} classes="supplement-label" />
    </ModalContentImage>
  )
}
